import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import PieChart from '../../../components/PieChart/PieChart';
import NoData from '../../../components/NoData/NoData';
import CommissionContractsStatisticsAPI from '../../../api/CommissionContractsStatisticsAPI';

const LEGACY_STANDARD_SENTINEL = '__LEGACY_STANDARD__';

type Props = { timeRange: { start: string; end: string }; compact?: boolean };

function CommissionContractsOffersDistribution({ timeRange, compact = false }: Props) {
  const { t } = useTranslation();
  const [labels, setLabels] = useState<string[]>([]);
  const [values, setValues] = useState<number[]>([]);

  useEffect(() => {
    let mounted = true;

    const fetchData = async () => {
      try {
        const res = await CommissionContractsStatisticsAPI.getOffersDistribution({
          startTime: timeRange.start,
          endTime: timeRange.end,
        });
        if (!mounted) return;
        const rawLabels = res.data?.labels || [];
        const defaultOfferName = t('commission_payment_offers.default_name') || 'Standard';
        const translatedLabels = rawLabels.map((label) =>
          label === LEGACY_STANDARD_SENTINEL ? defaultOfferName : label
        );
        setLabels(translatedLabels);
        setValues(res.data?.values || []);
      } catch (error) {
        console.error('Failed to load commission contracts offers distribution', {
          startTime: timeRange.start,
          endTime: timeRange.end,
          error,
        });
        if (!mounted) return;
        setLabels([]);
        setValues([]);
      }
    };

    fetchData();
    return () => {
      mounted = false;
    };
  }, [timeRange.start, timeRange.end, t]);

  return (
    <div className={compact ? undefined : 'space-y-2'}>
      {!compact && (
        <p className="text-xs text-muted-foreground">
          {t('stats.commission_contracts.offers_distribution_hint')}
        </p>
      )}
      {!labels.length ? (
        <NoData message={t('global.empty_results')} />
      ) : (
        <PieChart
          title={t('stats.commission_contracts.offers_distribution')}
          labels={labels}
          data={values}
          compact={compact}
        />
      )}
    </div>
  );
}

export default CommissionContractsOffersDistribution;
